const asTrimmedString = (value: unknown): string => {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return '';
};

const tryParseObject = (candidate: string): Record<string, unknown> | null => {
  const trimmed = candidate.trim();
  if (!trimmed) return null;
  try {
    const parsed = JSON.parse(trimmed) as unknown;
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as Record<string, unknown>;
    }
  } catch {
    return null;
  }
  return null;
};

const extractJsonCandidates = (raw: string): string[] => {
  const trimmed = raw.trim();
  if (!trimmed) return [];

  const candidates: string[] = [trimmed];
  const fencedMatch = trimmed.match(/```(?:json)?\s*([\s\S]*?)```/i);
  if (fencedMatch?.[1]) {
    candidates.unshift(fencedMatch[1]);
  }

  const firstBrace = trimmed.indexOf('{');
  const lastBrace = trimmed.lastIndexOf('}');
  if (firstBrace !== -1 && lastBrace > firstBrace) {
    candidates.unshift(trimmed.slice(firstBrace, lastBrace + 1));
  }

  return candidates;
};

export function parseFormDraftResponse(
  raw: string,
  allowedKeys: readonly string[]
): Record<string, string> | null {
  for (const candidate of extractJsonCandidates(raw)) {
    const parsed = tryParseObject(candidate);
    if (!parsed) continue;

    const result: Record<string, string> = {};
    for (const key of allowedKeys) {
      const value = asTrimmedString(parsed[key]);
      if (value) {
        result[key] = value;
      }
    }

    if (Object.keys(result).length > 0) {
      return result;
    }
  }

  return null;
}
